import { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { Headline, Div, Gutter, Loader, Title } from '@gaiads/telia-react-component-library';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { UserAssetResponseWithAutoOpen } from '../../types';
import { getMyAllAssets as getMyAllAssetsApi } from '../../utils';
import { showGrowlNotification } from '../../store/actions';
import AssetCard from '../../Components/AssetCard/AssetCard';

const MyAssets: FunctionComponent = () => {
  const [assets, setAssets] = useState<UserAssetResponseWithAutoOpen[]>();
  const [loading, setLoading] = useState<boolean>(true);

  const dispatch = useDispatch();
  const params = useParams<{ id?: string }>();

  const { t } = useTranslation('assets');

  const getMyAssets = async (openAutomaticallyWithId?: string) => {
    setLoading(true);
    const res = await getMyAllAssetsApi();
    if (!res) {
      dispatch(showGrowlNotification(t('getMyDevicesError'), 'error'));
    } else {
      setAssets(res.contents?.map(asset => ({ asset: asset, autoOpen: asset.id === openAutomaticallyWithId })) ?? undefined);
    }
    setLoading(false);
  };

  useEffect(() => {
    getMyAssets(params.id);
    // getMyAsset not listed as dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  if (loading) {
    return (
      <Div alignTextToCenter margin={{ vertical: 'xxlg' }}>
        <Loader />
      </Div>
    );
  }

  return (
    <>
      <Headline size={'lg'} margin={{ vertical: 'xlg' }}>
        {t('MyAssetsTitle')}
      </Headline>

      {!!assets?.length && (
        <Div>
          {assets.map(asset => (
            <Fragment key={asset.asset.id}>
              <AssetCard asset={asset} getAssets={getMyAssets} />
              <Gutter size={'sm'} />
            </Fragment>
          ))}
        </Div>
      )}

      {assets?.length === 0 && (
        <Title color={'black'} size={'md'}>
          {t('noAssetsFound')}
        </Title>
      )}
    </>
  );
};

export default MyAssets;
